export default "data:image/jpeg;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTg1Mzg4ZmJkMzU0OWRmOGE5YWRlOTljYTc2Y2NmYTkuanBnIjs="